import React from 'react';

// Activo existente de Transcaribe (Biblioteca de medios, misma imagen 250x130 que usa el barco de la pagina).
// No se descarga ni se copia: se referencia por ruta del mismo origen.
export const BOAT_SRC = '/wp-content/uploads/2023/07/tcbe-barco.png';

/**
 * Barco + olas: motivo decorativo de identidad (aria-hidden). Reutiliza la misma ola SVG (4 capas rgba(0,172,...)),
 * las mismas duraciones/retardos/keyframes (move-forever) y el mismo barco (boatMove) del tema, con nombres tc-*
 * y todo acotado bajo .tc-sched. Animacion 100 % CSS (transform): sin JS ni timers.
 */
export default function Sea() {
  return (
    <div className="tc-sched__sea" aria-hidden="true">
      <img className="tc-sched__boat" src={BOAT_SRC} width="250" height="130" alt="" decoding="async" loading="eager" draggable="false" />
      <svg className="tc-sched__swell" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 24 150 28" preserveAspectRatio="none" shapeRendering="auto" focusable="false">
        <defs>
          <path id="tc-sched-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
        </defs>
        <g className="tc-sched__swells">
          <use xlinkHref="#tc-sched-wave" x="48" y="0" fill="rgba(0,172,248,0.7)" />
          <use xlinkHref="#tc-sched-wave" x="48" y="3" fill="rgba(0,172,235,0.5)" />
          <use xlinkHref="#tc-sched-wave" x="48" y="5" fill="rgba(0,172,255,0.3)" />
          <use xlinkHref="#tc-sched-wave" x="48" y="7" fill="rgba(0,172,248,0.8)" />
        </g>
      </svg>
    </div>
  );
}
